module.exports = __webpack_public_path__ + "static/media/network.a810d667.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/OrganizationalUnit/network.svg
// module id = 2042
// module chunks = 0